var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "current",
    fillOpacity: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03593 5.60637L8.07969 0.104809C8.09809 0.0903191 8.12021 0.081314 8.1435 0.0788282C8.1668 0.0763424 8.19032 0.0804768 8.21137 0.0907565C8.23242 0.101036 8.25014 0.117045 8.2625 0.136943C8.27486 0.156841 8.28136 0.179822 8.28125 0.203247V1.41106C8.28125 1.48762 8.24531 1.56106 8.18594 1.60793L2.56094 6.00012L8.18594 10.3923C8.24687 10.4392 8.28125 10.5126 8.28125 10.5892V11.797C8.28125 11.9017 8.16094 11.9595 8.07969 11.8954L1.03593 6.39387C0.976068 6.34717 0.927638 6.28744 0.894327 6.21921C0.861016 6.15098 0.843702 6.07605 0.843702 6.00012C0.843702 5.9242 0.861016 5.84927 0.894327 5.78104C0.927638 5.71281 0.976068 5.65307 1.03593 5.60637Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.33a3082355b1da47ec831d9f13a3cdba.svg";
export { ForwardRef as ReactComponent };